import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './ReadActionType';
import * as actions from './ReadActions';
import * as services from './ReadService';

//------------------ Exam Data Read - start------------------//
function* fetchExamDataReadSaga(action) {
    console.log('Fetch Exam Data Read Saga action payload:', action.payload);
    try {
        const response = yield call(services.getAllExamDataRead, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }

        yield put(actions.fetchExamDataReadSuccess(response?.values));

    } catch (error) {
        let errorMessage = 'Failed to fetch read exam data.';
        console.error('Read Exam Data Get All Error :', {

            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchExamDataReadFailure(errorMessage));
    }
}

function* exportExamDataReadSaga(action) {
    console.log('Export Exam Data Read Saga action payload:', action.payload);
    try {
        const response = yield call(services.getAllExamDataRead, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.exportExamDataReadSuccess(response?.values));
    } catch (error) {
        let errorMessage = 'Failed to export read exam data.';
        console.error('Read Exam Data Export Error :', {

            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.exportExamDataReadFailure(errorMessage));
    }
}
//------------------ Exam Data Read - end------------------//


export default function* watchReadSaga() {
    yield takeEvery(types.FETCH_EXAM_DATA_READ_REQUEST, fetchExamDataReadSaga);
    yield takeEvery(types.EXPORT_EXAM_DATA_READ_REQUEST, exportExamDataReadSaga);
}